import Table from '@views/employee/table/Table'
import Monitoring from '@views/monitoring/Monitoring'
import React, {useEffect, useState, useCallback} from "react";
import { useDispatch, useSelector } from 'react-redux'

import {
	getIsReport,
	getReportCompanyList,
	getHistoryReportCompanyList,
} from '@store/report'

import { toStringByFormatting } from '@utils/dateUtils'

const getThisWeek = () => {
  const curr = new Date()
  const first = curr.getDate() - curr.getDay() + 1
  const last = first + 6

  const firstDay = new Date().setDate(first)
  const lastDay = new Date().setDate(last)

  return [firstDay, lastDay]
}

const Employee = () => {
	const dispatch = useDispatch()
	const { user } = useSelector(store => store.user)

	const [ openMonitoring, setOpenMonitoring ] = useState(false)
	const [ isReport, setIsReport ] = useState(null)

	const onCheckingReport = useCallback(async () => {
		if (!user) return
		const response = await dispatch(getIsReport({
			companyIdentify: user.id,
		}))
		setIsReport(response.payload.data)
	}, [dispatch, user])

	const onGetCompanyList = useCallback(async () => {
		if (!user) return
		await dispatch(getReportCompanyList({
			companyIdentify: user.id,
		}))
	}, [dispatch, user])

	const onGetHistoryCompanyList = useCallback(async () => {
		if (!user) return
		const week = getThisWeek()
		const startDate = toStringByFormatting(new Date(week[0]))
    const endDate = toStringByFormatting(new Date(week[1]))
		await dispatch(getHistoryReportCompanyList({
			companyIdentify: user.id,
			startDate,
			endDate,
		}))
	}, [dispatch, user])

	const onCloseMonitoring = () => {
		onGetHistoryCompanyList()
		setOpenMonitoring(false)
	}

	useEffect(() => onCheckingReport(), [onCheckingReport])

	useEffect(() => {
		if (typeof isReport !== 'boolean') return
		if (isReport) {
			onGetHistoryCompanyList()
		} else {
			onGetCompanyList()
			setTimeout(() => {
				setOpenMonitoring(true)
			}, 1000)
		}
	}, [isReport, onGetCompanyList, onGetHistoryCompanyList])

	return (
		<>
			<div>
				<h2>임원 정보 등록</h2>
				<Table />
			</div>

			<Monitoring open={openMonitoring} closeMonitoring={onCloseMonitoring}/>
		</>
	)
}

export default Employee